import { render, staticRenderFns } from "./ProductCouponDetails.vue?vue&type=template&id=375b489f&scoped=true"
import script from "./ProductCouponDetails.vue?vue&type=script&lang=js"
export * from "./ProductCouponDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductCouponDetails.vue?vue&type=style&index=0&id=375b489f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b489f",
  null
  
)

export default component.exports